"use client";

import styles from './_hcp-hear-experience.module.scss';
import Button from '@/components/button';
import CustomImage from '@/components/image';

const SpecialistBtn = ({ isSelected, imageSrc, alt, setSelection, name }) => {
  const selectDoc = () => {
    setSelection(name);
  }
  return (
    <Button
      className={`${styles.specialist_btn} ${isSelected ? styles.selected : ''}`}
      onMouseEnter={selectDoc}
      onTouchStart={selectDoc}
      data-gtm-event-category="Action"
      data-gtm-event-action="Click"
      data-gtm-event-label={name}
    >
      <CustomImage 
        src={imageSrc} 
        className={styles.specialist_image}
        width={150}
        height={150}
        alt={alt}
      />
    </Button>
  );
};

export default function HcpHearExperience({
  selection,
  setSelection,
  doctorData
}) {
  return (
    <section className={styles.container}>
      <div className={`container ${styles.content}`}>
        <h2>Hear directly from endocrinologists and patients about their CRENESSITY experience</h2>
        <div className={styles.specialists_container}>
          <div className={styles.specialists_text1}>
            <p className={styles.title}>Meet 3 CAH specialists</p>
            <p className="text-hcp-charcoal">These providers talk about the challenges of treating CAH and their recent experiences prescribing CRENESSITY.</p>
          </div>
          <div className={`${styles.specialists_buttons} ${selection === "" || selection === null ? '' : styles.has_selection}`}>
              {doctorData.map(doctor => (
                <SpecialistBtn
                  key={doctor.name}
                  isSelected={selection === doctor.name}
                  imageSrc={doctor.image}
                  setSelection={setSelection}
                  name={doctor.name}
                  alt={doctor.alt}
                />
              ))}
          </div>
          <div className={styles.specialists_text2}>
            {selection === null || selection === "" 
            ? (<p className={styles.instructions}>Select an endocrinologist’s image to learn more.</p>) 
            : (
              <>
                <p className={styles.name}>{doctorData.find(doctor => doctor.name === selection)?.name}</p>
                <p className={styles.specialty}>{doctorData.find(doctor => doctor.name === selection)?.specialty}</p>
                <p className={styles.location}>{doctorData.find(doctor => doctor.name === selection)?.location}</p>
              </>
            )}
          </div>
        </div>

        {/* <div className={styles.closing_text}>
          <p><strong>Stay tuned for upcoming videos to see these endocrinologists reflect on treating classic CAH with CRENESSITY.</strong></p>
        </div> */}
      </div>
    </section>
  );
}
